// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import droplets03Icon from "@/assets/icons/droplets-03.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Droplets03IconProps = Omit<IconProps, "name">;

export function Droplets03Icon(props: Droplets03IconProps): React.ReactNode {
  return <Icon name={droplets03Icon} {...props} />;
}
